export default "__VITE_ASSET__O5yrrXi7__"